import { render, staticRenderFns } from "./View_WeekRankings.vue?vue&type=template&id=4ee1bcfe&scoped=true&"
import script from "./View_WeekRankings.vue?vue&type=script&lang=js&"
export * from "./View_WeekRankings.vue?vue&type=script&lang=js&"
import style0 from "./View_WeekRankings.vue?vue&type=style&index=0&id=4ee1bcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee1bcfe",
  null
  
)

export default component.exports